function requiredValidator(value: unknown): boolean {
  return ![null, undefined].includes(value as null |undefined);
}

export default requiredValidator;
